// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay_3XJLS {
  z-index: 999;
  position: absolute;
}

.bg_pBp6J {
  background-color: var(--_00000020-background);
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
}

.contactinfo_spGVN {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .fileInfo_IbgKQ {
    display: flex;
    align-items: center;
    justify-content: end;

    input {
      background-color: var(--white-background);
      width: 50%;
      font-size: 20px;
      padding: 8px;
      outline: none;
      border: none;

      &:disabled {
        background-color: transparent;
      }

      &::placeholder {
        color: var(--_71717a-color);
      }
    }

  }

  .columnRightContactInfo_EDfCA {
    display: flex;
    flex-direction: column;
    align-items: end;
    overflow: hidden;
    gap: 10px;
    padding-left: 20px;
    width: 100%;

    .btnContactInfoContainer_axngA {
      display: flex;
      align-items: center;
      gap: 5px;

      button {
        svg {
          color: var(--969595-fill);
          fill: var(--969595-fill);
        }

        .activeBtn_d5JRX {
          color: var(--_10a37f-background);
          fill: var(--_10a37f-background);
        }
      }

      svg {
        width: 20px;
        height: 20px;
      }
    }

    .tagsContainer_Ijf8i {
      display: flex;
      align-items: center;
      gap: 10px;
      width: 100%;
      overflow-x: auto;

      .tag_IkQ30 {
        display: flex;
        align-items: center;
        gap: 5px;

        span {
          min-width: 60px;
        }
      }
    }
  }

}

.popupNewContaier_tfxct {
  display: flex;
  width: 100%;

  .leftSide_P6z5x {
    height: 100%;
    max-width: 250px;
    min-width: 240px;
  }

  @media (width<=768px) {
    flex-direction: column;

    .leftSide_P6z5x {
      margin: 0 auto;
      max-width: 90%;
    }
  }
}

.taxRetentionContainer_rOe7u {
  flex: 1 1;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.infoInsumo_C21TX {
  display: flex;
  align-items: center;
  gap: 10px;

  img {
    width: 30px;
    height: 30px;
  }

  >div {
    display: flex;
    flex-direction: column;

    span {
      font-size: 14px;
      color: var(--_71717a-color);
    }

    p {
      margin: 0;
      color: var(--_22222268-color);
      font-weight: 500;
    }
  }
}

.sectionContact_osYEV {
  h3 {
    color: var(--_10a37f-background);
    margin: 20px 0 !important;
  }

  .infoLabel__9hqE,
  .infoLabelIdentification_ufWVB {
    background-color: var(--white-background);
    padding: 10px 20px;
    border: 1px solid var(--ececf1-border);
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 50px;

    >div {}

    .row_LayDb {
      display: flex;
      gap: 10px;
      box-sizing: border-box;
      flex-wrap: wrap;
    }
  }

  .infoLabelIdentification_ufWVB {
    gap: 10px;
  }
}

.newClientContainer_QwBeY {
  box-sizing: border-box;
  width: 100%;
  padding: 10px;
  margin: 0 auto;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  animation: scaleUp_VHUPc 300ms ease-out forwards;
  -webkit-animation: scaleUp_VHUPc 300ms ease-out forwards;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (width<=768px) {
    width: 90%;
  }




}



.newProductContainer_DkPHo {
  position: fixed;
  top: 50%;
  left: 50%;
  background-color: var(--white-background);
  width: 100%;
}

.typeClient_qz85s {
  display: flex;
  background-color: var(--f3-background);
  border-radius: 6px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  -ms-border-radius: 6px;
  -o-border-radius: 6px;
  padding: 6px;
  gap: 10px;
  width: 100%;
  box-sizing: border-box;

  button {
    background-color: transparent;
    cursor: pointer;
    color: var(--_9-color);
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    border-radius: 8px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
    border: 1px solid transparent !important;
    flex: 1 1;
    background-color: transparent;
    max-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .selected_1etU3 {
    background-color: var(--white-background);
    color: var(--_0d-color);
    border-radius: 8px;
    border: 1px solid var(--_0000002b-border) !important;
    box-shadow:
      0 0 2px 0 var(--_00000008-shadow),
      0 0 0 0 var(--_00000000-shadow),
      0 0 0 0 var(--_00000000-shadow);
  }
}

.infoContact_dmjQ4 {
  .row_LayDb {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    >div {
      flex: 1 1;

      p {
        margin: 0;
        color: var(--_2-color);
        font-weight: 500;
      }
    }

    .edit_fjeGB {
      display: flex;
      align-items: center;
      gap: 10px;
    }

  }
}

.CheckedInput_P4dkg {
  flex: 1 1;
  box-sizing: border-box;
  position: relative;
  min-width: 49%;

  input[type="checkbox"] {
    accent-color: var(--_10a37f-background);
  }

  input[type="text"] {
    border: none;
    outline: none;
    font-size: 14px;
    font-weight: 400;
    color: var(--_75-color);
    height: 31px;
    min-height: 31px;
    background-color: var(--f4-background);
    padding: 0 9px;
    box-sizing: border-box;
    width: 100%;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
  }

  p {
    margin: 0;
    color: var(--_2-color);
    font-weight: 500;
  }

  span {
    font-size: 14px;
    color: var(--_71717a-color);
  }
}

.formNewProduct_VZefX {
  width: 90%;
  margin: 0 auto;
  height: 100vh;
  overflow: scroll;
  padding-bottom: 100px;
  box-sizing: border-box;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (width<=768px) {
    height: fit-content;
  }
}

.formNewProduct_VZefX .label_OQRhY {
  padding: 4px 0;
}


.ButtonLabelCommponent_zhGyg {
  display: flex;
  flex-direction: column;
  gap: 10px;

  >div {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .button_EhpLf {
      text-decoration: underline;
      cursor: pointer;
      -webkit-user-select: none;
      user-select: none;
      font-size: 14px;
      font-weight: 600;
      color: var(--_2-color);
    }
  }

  .edit_fjeGB {
    display: flex;
    gap: 10px;
    width: fit-content;

    span {
      -webkit-user-select: none;
              user-select: none;
      color: var(--_71717a-color);
    }

    input {
      border: none;
      outline: none;
      background-color: var(--f4-background);
      padding: 12px;
      box-sizing: border-box;
      font-family: "Inter", sans-serif;

      &[disabled] {
        background-color: transparent;
      }
    }

    .button_EhpLf {
      text-decoration: underline;
      cursor: pointer;
      -webkit-user-select: none;
      user-select: none;
      font-size: 14px;
      font-weight: 600;
      color: var(--_2-color);
      display: none;
    }

    &:hover {
      .button_EhpLf {
        display: block;
      }
    }
  }
}



.customLabel_yG5Wx {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;

  p {
    color: var(--black-color);
  }
}

.infoCustomLabel_nte_T {
  display: flex;
  align-items: center;
  gap: 10px;

  input {
    width: 30%;
    border: none;
    outline: none;
    background-color: var(--f4-background);
    padding: 12px;
    box-sizing: border-box;
    font-family: "Inter", sans-serif;
  }
}

.btnInsumoinfo_U1Y1k {
  display: flex;
  align-items: center;
  gap: 10px;
}

.insumoRow_uxpuJ {
  input {

    border: none;
    outline: none;
    background-color: var(--f4-background);
    padding: 12px;
    box-sizing: border-box;
    font-family: "Inter", sans-serif;
  }
}

.editBtn_VhJQL {
  border: 1px solid var(--cb-border);
  height: 30px;
  min-width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  cursor: pointer;

}

.btnContainer_xtnHf {
  opacity: 0;
}

.customLabel_yG5Wx:hover {
  .btnContainer_xtnHf {
    opacity: 1;
  }
}


.searchContactInput_Ph_pC {
  font-size: 18px;
  font-weight: 500;
  margin: 0;
  width: 100%;
  border-radius: 8px;
  padding: 6px;
  border: none;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
  background-color: var(--f4-background);
  outline: none;
}

.inputContainer_nKrif {
  display: flex;
  width: 100%;
  align-items: center;
  background-color: var(--f4-background);

  input::placeholder {
    color: var(--_71717a-color);
  }
}

.inputContainer_nKrif {
  position: relative;
  box-sizing: border-box;
  border-radius: 6px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  -ms-border-radius: 6px;
  -o-border-radius: 6px;
  resize: none;

  .searchContactInput_Ph_pC {
    font-size: 18px;
    font-weight: 500;
    margin: 0;
    width: 100%;
    border-radius: 8px;
    padding: 6px;
    border: none;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
    background-color: var(--f4-background);
    outline: none;
  }
}

.deleteButtonContainer_k8Hia {
  padding-left: 5px;
  display: none;
}

.categoryButton_UjoGj {}


.categoryButton_UjoGj:hover {
  .deleteButtonContainer_k8Hia {
    display: block;
  }

}



.newProductContainerPopup_Pshlw {
  .row_LayDb {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/NewAsset/NewAsset.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;EAC7C,aAAa;EACb,YAAY;EACZ,eAAe;EACf,MAAM;EACN,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;;EAEnB;IACE,aAAa;IACb,mBAAmB;IACnB,oBAAoB;;IAEpB;MACE,yCAAyC;MACzC,UAAU;MACV,eAAe;MACf,YAAY;MACZ,aAAa;MACb,YAAY;;MAEZ;QACE,6BAA6B;MAC/B;;MAEA;QACE,2BAA2B;MAC7B;IACF;;EAEF;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,WAAW;;IAEX;MACE,aAAa;MACb,mBAAmB;MACnB,QAAQ;;MAER;QACE;UACE,yBAAyB;UACzB,wBAAwB;QAC1B;;QAEA;UACE,gCAAgC;UAChC,+BAA+B;QACjC;MACF;;MAEA;QACE,WAAW;QACX,YAAY;MACd;IACF;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,WAAW;MACX,gBAAgB;;MAEhB;QACE,aAAa;QACb,mBAAmB;QACnB,QAAQ;;QAER;UACE,eAAe;QACjB;MACF;IACF;EACF;;AAEF;;AAEA;EACE,aAAa;EACb,WAAW;;EAEX;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;;IAEtB;MACE,cAAc;MACd,cAAc;IAChB;EACF;AACF;;AAEA;EACE,SAAO;EACP,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;;EAET;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;;IAEtB;MACE,eAAe;MACf,2BAA2B;IAC7B;;IAEA;MACE,SAAS;MACT,6BAA6B;MAC7B,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE;IACE,gCAAgC;IAChC,yBAAyB;EAC3B;;EAEA;;IAEE,yCAAyC;IACzC,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;;IAET,MAAM;;IAEN;MACE,aAAa;MACb,SAAS;MACT,sBAAsB;MACtB,eAAe;IACjB;EACF;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,gDAA0C;EAC1C,wDAAkD;;EAElD;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;;;;AAKF;;;;AAIA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,sBAAsB;;EAEtB;IACE,6BAA6B;IAC7B,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,wCAAwC;IACxC,SAAO;IACP,6BAA6B;IAC7B,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,yCAAyC;IACzC,uBAAuB;IACvB,kBAAkB;IAClB,oDAAoD;IACpD;;;qCAGiC;EACnC;AACF;;AAEA;EACE;IACE,aAAa;IACb,eAAe;IACf,SAAS;;IAET;MACE,SAAO;;MAEP;QACE,SAAS;QACT,sBAAsB;QACtB,gBAAgB;MAClB;IACF;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;IACX;;EAEF;AACF;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;;EAEd;IACE,uCAAuC;EACzC;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,sCAAsC;IACtC,cAAc;IACd,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,SAAS;IACT,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,2BAA2B;EAC7B;AACF;;AAEA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;;EAEtB;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;;IAE9B;MACE,0BAA0B;MAC1B,eAAe;MACf,yBAAyB;MACzB,iBAAiB;MACjB,eAAe;MACf,gBAAgB;MAChB,sBAAsB;IACxB;EACF;;EAEA;IACE,aAAa;IACb,SAAS;IACT,kBAAkB;;IAElB;MACE,yBAAiB;cAAjB,iBAAiB;MACjB,2BAA2B;IAC7B;;IAEA;MACE,YAAY;MACZ,aAAa;MACb,sCAAsC;MACtC,aAAa;MACb,sBAAsB;MACtB,gCAAgC;;MAEhC;QACE,6BAA6B;MAC/B;IACF;;IAEA;MACE,0BAA0B;MAC1B,eAAe;MACf,yBAAyB;MACzB,iBAAiB;MACjB,eAAe;MACf,gBAAgB;MAChB,sBAAsB;MACtB,aAAa;IACf;;IAEA;MACE;QACE,cAAc;MAChB;IACF;EACF;AACF;;;;AAIA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;;EAEX;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;;EAET;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sCAAsC;IACtC,aAAa;IACb,sBAAsB;IACtB,gCAAgC;EAClC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;;IAEE,YAAY;IACZ,aAAa;IACb,sCAAsC;IACtC,aAAa;IACb,sBAAsB;IACtB,gCAAgC;EAClC;AACF;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;;AAEjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,sCAAsC;;EAEtC;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;;EAEZ;IACE,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,sCAAsC;IACtC,aAAa;EACf;AACF;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA,uBAAiB;;;AAGjB;EACE;IACE,cAAc;EAChB;;AAEF;;;;AAIA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".overlay {\n  z-index: 999;\n  position: absolute;\n}\n\n.bg {\n  background-color: var(--_00000020-background);\n  height: 100vh;\n  width: 100vw;\n  position: fixed;\n  top: 0;\n  left: 0;\n}\n\n.contactinfo {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n\n  .fileInfo {\n    display: flex;\n    align-items: center;\n    justify-content: end;\n\n    input {\n      background-color: var(--white-background);\n      width: 50%;\n      font-size: 20px;\n      padding: 8px;\n      outline: none;\n      border: none;\n\n      &:disabled {\n        background-color: transparent;\n      }\n\n      &::placeholder {\n        color: var(--_71717a-color);\n      }\n    }\n\n  }\n\n  .columnRightContactInfo {\n    display: flex;\n    flex-direction: column;\n    align-items: end;\n    overflow: hidden;\n    gap: 10px;\n    padding-left: 20px;\n    width: 100%;\n\n    .btnContactInfoContainer {\n      display: flex;\n      align-items: center;\n      gap: 5px;\n\n      button {\n        svg {\n          color: var(--969595-fill);\n          fill: var(--969595-fill);\n        }\n\n        .activeBtn {\n          color: var(--_10a37f-background);\n          fill: var(--_10a37f-background);\n        }\n      }\n\n      svg {\n        width: 20px;\n        height: 20px;\n      }\n    }\n\n    .tagsContainer {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      width: 100%;\n      overflow-x: auto;\n\n      .tag {\n        display: flex;\n        align-items: center;\n        gap: 5px;\n\n        span {\n          min-width: 60px;\n        }\n      }\n    }\n  }\n\n}\n\n.popupNewContaier {\n  display: flex;\n  width: 100%;\n\n  .leftSide {\n    height: 100%;\n    max-width: 250px;\n    min-width: 240px;\n  }\n\n  @media (width<=768px) {\n    flex-direction: column;\n\n    .leftSide {\n      margin: 0 auto;\n      max-width: 90%;\n    }\n  }\n}\n\n.taxRetentionContainer {\n  flex: 1;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n}\n\n.infoInsumo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n\n  img {\n    width: 30px;\n    height: 30px;\n  }\n\n  >div {\n    display: flex;\n    flex-direction: column;\n\n    span {\n      font-size: 14px;\n      color: var(--_71717a-color);\n    }\n\n    p {\n      margin: 0;\n      color: var(--_22222268-color);\n      font-weight: 500;\n    }\n  }\n}\n\n.sectionContact {\n  h3 {\n    color: var(--_10a37f-background);\n    margin: 20px 0 !important;\n  }\n\n  .infoLabel,\n  .infoLabelIdentification {\n    background-color: var(--white-background);\n    padding: 10px 20px;\n    border: 1px solid var(--ececf1-border);\n    border-radius: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 50px;\n\n    >div {}\n\n    .row {\n      display: flex;\n      gap: 10px;\n      box-sizing: border-box;\n      flex-wrap: wrap;\n    }\n  }\n\n  .infoLabelIdentification {\n    gap: 10px;\n  }\n}\n\n.newClientContainer {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 10px;\n  margin: 0 auto;\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n  animation: scaleUp 300ms ease-out forwards;\n  -webkit-animation: scaleUp 300ms ease-out forwards;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  @media (width<=768px) {\n    width: 90%;\n  }\n\n\n\n\n}\n\n\n\n.newProductContainer {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  background-color: var(--white-background);\n  width: 100%;\n}\n\n.typeClient {\n  display: flex;\n  background-color: var(--f3-background);\n  border-radius: 6px;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  -ms-border-radius: 6px;\n  -o-border-radius: 6px;\n  padding: 6px;\n  gap: 10px;\n  width: 100%;\n  box-sizing: border-box;\n\n  button {\n    background-color: transparent;\n    cursor: pointer;\n    color: var(--_9-color);\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n    border-radius: 8px;\n    -webkit-border-radius: 8px;\n    -moz-border-radius: 8px;\n    -ms-border-radius: 8px;\n    -o-border-radius: 8px;\n    border: 1px solid transparent !important;\n    flex: 1;\n    background-color: transparent;\n    max-height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .selected {\n    background-color: var(--white-background);\n    color: var(--_0d-color);\n    border-radius: 8px;\n    border: 1px solid var(--_0000002b-border) !important;\n    box-shadow:\n      0 0 2px 0 var(--_00000008-shadow),\n      0 0 0 0 var(--_00000000-shadow),\n      0 0 0 0 var(--_00000000-shadow);\n  }\n}\n\n.infoContact {\n  .row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n\n    >div {\n      flex: 1;\n\n      p {\n        margin: 0;\n        color: var(--_2-color);\n        font-weight: 500;\n      }\n    }\n\n    .edit {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n    }\n\n  }\n}\n\n.CheckedInput {\n  flex: 1;\n  box-sizing: border-box;\n  position: relative;\n  min-width: 49%;\n\n  input[type=\"checkbox\"] {\n    accent-color: var(--_10a37f-background);\n  }\n\n  input[type=\"text\"] {\n    border: none;\n    outline: none;\n    font-size: 14px;\n    font-weight: 400;\n    color: var(--_75-color);\n    height: 31px;\n    min-height: 31px;\n    background-color: var(--f4-background);\n    padding: 0 9px;\n    box-sizing: border-box;\n    width: 100%;\n    border-radius: 4px;\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n  }\n\n  p {\n    margin: 0;\n    color: var(--_2-color);\n    font-weight: 500;\n  }\n\n  span {\n    font-size: 14px;\n    color: var(--_71717a-color);\n  }\n}\n\n.formNewProduct {\n  width: 90%;\n  margin: 0 auto;\n  height: 100vh;\n  overflow: scroll;\n  padding-bottom: 100px;\n  box-sizing: border-box;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  @media (width<=768px) {\n    height: fit-content;\n  }\n}\n\n.formNewProduct .label {\n  padding: 4px 0;\n}\n\n\n.ButtonLabelCommponent {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n\n  >div {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    .button {\n      text-decoration: underline;\n      cursor: pointer;\n      -webkit-user-select: none;\n      user-select: none;\n      font-size: 14px;\n      font-weight: 600;\n      color: var(--_2-color);\n    }\n  }\n\n  .edit {\n    display: flex;\n    gap: 10px;\n    width: fit-content;\n\n    span {\n      user-select: none;\n      color: var(--_71717a-color);\n    }\n\n    input {\n      border: none;\n      outline: none;\n      background-color: var(--f4-background);\n      padding: 12px;\n      box-sizing: border-box;\n      font-family: \"Inter\", sans-serif;\n\n      &[disabled] {\n        background-color: transparent;\n      }\n    }\n\n    .button {\n      text-decoration: underline;\n      cursor: pointer;\n      -webkit-user-select: none;\n      user-select: none;\n      font-size: 14px;\n      font-weight: 600;\n      color: var(--_2-color);\n      display: none;\n    }\n\n    &:hover {\n      .button {\n        display: block;\n      }\n    }\n  }\n}\n\n\n\n.customLabel {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n\n  p {\n    color: var(--black-color);\n  }\n}\n\n.infoCustomLabel {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n\n  input {\n    width: 30%;\n    border: none;\n    outline: none;\n    background-color: var(--f4-background);\n    padding: 12px;\n    box-sizing: border-box;\n    font-family: \"Inter\", sans-serif;\n  }\n}\n\n.btnInsumoinfo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.insumoRow {\n  input {\n\n    border: none;\n    outline: none;\n    background-color: var(--f4-background);\n    padding: 12px;\n    box-sizing: border-box;\n    font-family: \"Inter\", sans-serif;\n  }\n}\n\n.editBtn {\n  border: 1px solid var(--cb-border);\n  height: 30px;\n  min-width: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  cursor: pointer;\n\n}\n\n.btnContainer {\n  opacity: 0;\n}\n\n.customLabel:hover {\n  .btnContainer {\n    opacity: 1;\n  }\n}\n\n\n.searchContactInput {\n  font-size: 18px;\n  font-weight: 500;\n  margin: 0;\n  width: 100%;\n  border-radius: 8px;\n  padding: 6px;\n  border: none;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  background-color: var(--f4-background);\n  outline: none;\n}\n\n.inputContainer {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  background-color: var(--f4-background);\n\n  input::placeholder {\n    color: var(--_71717a-color);\n  }\n}\n\n.inputContainer {\n  position: relative;\n  box-sizing: border-box;\n  border-radius: 6px;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  -ms-border-radius: 6px;\n  -o-border-radius: 6px;\n  resize: none;\n\n  .searchContactInput {\n    font-size: 18px;\n    font-weight: 500;\n    margin: 0;\n    width: 100%;\n    border-radius: 8px;\n    padding: 6px;\n    border: none;\n    -webkit-border-radius: 8px;\n    -moz-border-radius: 8px;\n    -ms-border-radius: 8px;\n    -o-border-radius: 8px;\n    background-color: var(--f4-background);\n    outline: none;\n  }\n}\n\n.deleteButtonContainer {\n  padding-left: 5px;\n  display: none;\n}\n\n.categoryButton {}\n\n\n.categoryButton:hover {\n  .deleteButtonContainer {\n    display: block;\n  }\n\n}\n\n\n\n.newProductContainerPopup {\n  .row {\n    flex-direction: column;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `overlay_3XJLS`,
	"bg": `bg_pBp6J`,
	"contactinfo": `contactinfo_spGVN`,
	"fileInfo": `fileInfo_IbgKQ`,
	"columnRightContactInfo": `columnRightContactInfo_EDfCA`,
	"btnContactInfoContainer": `btnContactInfoContainer_axngA`,
	"activeBtn": `activeBtn_d5JRX`,
	"tagsContainer": `tagsContainer_Ijf8i`,
	"tag": `tag_IkQ30`,
	"popupNewContaier": `popupNewContaier_tfxct`,
	"leftSide": `leftSide_P6z5x`,
	"taxRetentionContainer": `taxRetentionContainer_rOe7u`,
	"infoInsumo": `infoInsumo_C21TX`,
	"sectionContact": `sectionContact_osYEV`,
	"infoLabel": `infoLabel__9hqE`,
	"infoLabelIdentification": `infoLabelIdentification_ufWVB`,
	"row": `row_LayDb`,
	"newClientContainer": `newClientContainer_QwBeY`,
	"scaleUp": `scaleUp_VHUPc`,
	"newProductContainer": `newProductContainer_DkPHo`,
	"typeClient": `typeClient_qz85s`,
	"selected": `selected_1etU3`,
	"infoContact": `infoContact_dmjQ4`,
	"edit": `edit_fjeGB`,
	"CheckedInput": `CheckedInput_P4dkg`,
	"formNewProduct": `formNewProduct_VZefX`,
	"label": `label_OQRhY`,
	"ButtonLabelCommponent": `ButtonLabelCommponent_zhGyg`,
	"button": `button_EhpLf`,
	"customLabel": `customLabel_yG5Wx`,
	"infoCustomLabel": `infoCustomLabel_nte_T`,
	"btnInsumoinfo": `btnInsumoinfo_U1Y1k`,
	"insumoRow": `insumoRow_uxpuJ`,
	"editBtn": `editBtn_VhJQL`,
	"btnContainer": `btnContainer_xtnHf`,
	"searchContactInput": `searchContactInput_Ph_pC`,
	"inputContainer": `inputContainer_nKrif`,
	"deleteButtonContainer": `deleteButtonContainer_k8Hia`,
	"categoryButton": `categoryButton_UjoGj`,
	"newProductContainerPopup": `newProductContainerPopup_Pshlw`
};
export default ___CSS_LOADER_EXPORT___;
